import { Link, Text } from '@lego/klik-ui';
import { Link as ReactRouterLink } from 'react-router-dom';
import { UserNameLink } from '@/components/common/UserNameLink';
import type { ApplicationResponse } from '@/hooks/application';
import { dateTimeFormat } from '@/utility/date';
import { paths } from '@/utility/global_paths';
import { PlaceholderText } from '../../PlaceholderText';
import { createColumnHelper } from '../appTable';

const columnHelper = createColumnHelper<ApplicationResponse>();

export const getApplicationTableColumns = (workspaceId: number) =>
  columnHelper.columns([
    columnHelper.accessor('id', {
      cell: (info) => (
        <Text fontFamily="mono" fontSize="sm">
          {info.getValue()}
        </Text>
      ),
      header: 'ID',
      meta: { filterVariant: { constraint: /^[0-9]*$/, type: 'singleSearch' } },
      size: 96,
    }),
    columnHelper.accessor('name', {
      cell: (info) => info.getValue(),
      header: 'Name',
      meta: { filterVariant: { type: 'singleSearch' } },
    }),
    columnHelper.accessor('stableVersionId', {
      cell: (info) => {
        const versionId = info.getValue();
        return versionId != null ? (
          <Link
            as={ReactRouterLink}
            p={0}
            to={paths.applicationVersionById(workspaceId, info.row.original.id, versionId)}
          >
            {versionId}
          </Link>
        ) : (
          <PlaceholderText>Stable version not set</PlaceholderText>
        );
      },
      enableSorting: false,
      header: 'Stable Version ID',
    }),
    columnHelper.accessor('latestVersionId', {
      cell: (info) => {
        const versionId = info.getValue();
        return versionId != null ? (
          <Link
            as={ReactRouterLink}
            p={0}
            to={paths.applicationVersionById(workspaceId, info.row.original.id, versionId)}
          >
            {versionId}
          </Link>
        ) : (
          <PlaceholderText>No versions exist</PlaceholderText>
        );
      },
      enableSorting: false,
      header: 'Latest Version ID',
    }),
    columnHelper.accessor('updatedByOid', {
      cell: (info) => <UserNameLink oid={info.getValue()} />,
      enableSorting: false,
      header: 'Updated By',
    }),
    columnHelper.accessor('updatedAt', {
      cell: (info) => new Date(info.getValue()).toLocaleString(dateTimeFormat.local),
      header: 'Updated At',
      meta: { filterVariant: { type: 'dateRange' } },
    }),
    columnHelper.accessor('createdByOid', {
      cell: (info) => <UserNameLink oid={info.getValue()} />,
      enableSorting: false,
      header: 'Created By',
    }),
    columnHelper.accessor('createdAt', {
      cell: (info) => new Date(info.getValue()).toLocaleString(dateTimeFormat.local),
      header: 'Created At',
      meta: { filterVariant: { type: 'dateRange' } },
    }),
  ]);
